import { useContext, useState } from 'react';
import ErrorAlert from '../../atoms/ErrorAlert/ErrorAlert';
import WideButton from '../../atoms/WideButton/WideButton';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';
import Dialog from '../Dialog/Dialog';
import LabelledInput from '../../atoms/LabelledInput/LabelledInput';
import './GatherDobDialog.scss';

interface GatherDobDialogProps {
    onClose: (dob: string) => void;
    onCancel: () => void;
}

const GatherDobDialog = (props: GatherDobDialogProps) => {

    const { giftsApi } = useContext(GlobalVariablesContext);

    const [dob, setDob] = useState('');

    const [error, setError] = useState('');

    const handleSaveButtonClick = async () => {
        await giftsApi
            .editAccount({ dateOfBirth: dob })
            .then(data => {
                props.onClose(dob);
            })
            .catch(error => {
                setError(error.response.data.error);
            });
    }

    const handleCancelButtonClick = () => {
        props.onCancel();
    }

    return (
        <Dialog className="gather-dob-dialog" onClose={props.onCancel}>
            <h1>Date of Birth</h1>
            <LabelledInput name="dob" label="Please specify your date of birth so that your friends will know when to celebrate your special day!" type="date" value={dob} onChange={e => setDob(e.target.value)} required={true} />
            {error && <ErrorAlert title='Cannot Save Date of Birth' message={error} />}
            <WideButton label='Save' onClick={handleSaveButtonClick} />
            <WideButton label='Not Right Now' variant='red' onClick={handleCancelButtonClick} />
        </Dialog>
    );
}

export default GatherDobDialog;